import { type DetailedPublicTemplateResponse } from '@/types/global-types';
import { isXmlFormTemplate } from '@heidi/templates/data';

/**
 * XML source the community page may preview or fill.
 *
 * Gated by `release-growth-enable-xml-form`. An S3 PDF wins when both are
 * present, matching the preview: a dual-format form keeps the PDF fill path.
 */
export const communityXmlSource = (
  template: DetailedPublicTemplateResponse,
  isXmlFormEnabled: boolean
): string | null => {
  if (!isXmlFormEnabled) return null;

  const content = template.template_content;
  if (content.s3_object_key) return null;
  if (
    !isXmlFormTemplate({
      template_category: template.template_category,
      form_format: content.form_format,
    })
  ) {
    return null;
  }

  return content.xml_source ?? null;
};
